import { FC, useMemo } from "react";
import { useTablePropsContext } from "../../../context";
import { useFiltersInfo } from "../utils";
import { AddFilter } from "./AddFilter";
import { Filter } from "./Filter";
import { ResetFilter } from "./ResetFilter";

import styles from "./styles.module.scss";

export const SimpleFilters: FC = (() => {
  const { availableColumns, usedFiltersCount, columnFilters } = useFiltersInfo();
  const { pinnedFilters } = useTablePropsContext();

  const usedColumns = useMemo(
    () => Array.from(new Set([
      ...pinnedFilters
        ?.map(id => availableColumns.find(x => x.id === id)!)
        .filter(Boolean) || [],
      ...availableColumns
        .filter(c => columnFilters?.some(x => x.id === c.id))
        .filter(c => !pinnedFilters?.some(id => id === c.id)),
    ])),
    [ availableColumns, columnFilters, pinnedFilters ],
  );

  const unusedColumns = useMemo(
    () => availableColumns
      .filter(c => !columnFilters?.some(x => x.id === c.id))
      .filter(c => !pinnedFilters?.some(id => id === c.id)),
    [ availableColumns, columnFilters, pinnedFilters ],
  );

  if (!availableColumns.length) {
    return null;
  }

  return (
    <div className={styles.root}>
      {usedColumns.map(c => <Filter key={c.id} column={c} />)}
      {!!unusedColumns.length && <AddFilter unusedColumns={unusedColumns} />}
      {!!usedFiltersCount && <ResetFilter />}
    </div>
  );
});
